import React from "react";

const First = ({ msg, color }) => {
  return (
    <>
 
  <ul class="list-disc pl-4 md:p-10 space-y-3 text-gray-500 mt-2">
    <li>
      Kiongozi Kufungua akaunti na kujisajili taarifa zake
      katika mfumo.
    </li>
    <li>
      Kiongozi Kupakua na kujaza sampluli za katiba na kanuni
      katika mfumo.
    </li>
    <li>
      Kiongozi wa Chama ataweka taarifa muhimu za Chama
      anachotaka kukisajili ikiwemo Jina la Chama, Aina ya
      Mchezo, Anuani, Mkoa.
    </li>
    <li>
      Kutuma maombi BMT kupitia mfumo huu. Maombi haya
      yaambatanishe na kuweka katika mfumo nyaraka zifuatazo: -
      <ul
        role="list"
        class="list-decimal pl-5 space-y-3 text-gray-500 mt-2"
      >
        <li>
          Muhtasari wa kikao cha Wanachama kilichofikia uamuzi
          wa kuunda chamana kupitisha Katiba,
        </li>
        <li>Nakala ya Katiba ya Chama,</li>
        <li>Nakala ya Kanuni za fedha za chama,</li>
        <li>
          Nakala ya Kanuni za uendeshaji wa shughuli za Chama,
        </li>
        <li>
          Orodha ya majina ya Uanachama wake na namba za
          Uanachama kwa Msajili.
        </li>
        <li>Kujaza fomu za usajili NSC 01 na NSC 02.</li>
        <li>
          Kiongozi atengeneze namba ya malipo (Control No., na
          kulipia gharama za usajili kwa ajili ya kulipia
          gharama za usajili wa chama alichoomba. (CONTROL Na.
          mbili, moja ilipiwe wilayani, nyingine iwasilishwe
          BMT.
        </li>
      </ul>
      <br />
      <li>Kuwasilisha taarifa kwa msajili msaidizi.</li>
      <li>
        Baada ya kuwasilishwa maombi kwenye mfumo, Msajili
        Msaidizi atapitia taarifa za chama pamoja na fomu
        alizojaza na kama ziko sawa atatuma maombi hayo kwa
        Msajili wa Vyama vya Michezo, BMT.
      </li>
    </li>
    <li>
      Msajili akishayapokea maombi hayo katika mfumo atayahakiki
      na endapo hataona upungufu wowote, atakisajili Chama hicho
      kwa kufanya yafuatayo:-
      <ul
        role="list"
        class="list-decimal pl-5 space-y-3 text-gray-500 mt-2"
      >
        <li>Kufanya usajili</li>
        <li>Kutoa nakala hati ya Usajili;</li>
        <li>
          Kuchukua nakala ngumu ya cheti kutoka kwa msajili
          msaidizi.
        </li>
      </ul>
    </li>
  </ul>
  </>
  );
};

export default First;
